import CampaignBannerSlide from 'gatsby-theme-husky/src/common/Carousel/CampaignBannerSlide/CampaignBannerSlide';

import './campaignBannerSlideOverride.scss';

export default CampaignBannerSlide;